export const SpecialRequirements = {
  bbq_grill: "BBQ Grill",
  fireplace: "Fireplace (wood stove)",
  firepit: "Firepit (outdoor)",
  pet_cleaning: "Pet cleaning",
  wash_dishes: "Wash dirty dishes",
  patio: "Deck or patio",
  offsite_laundry: "Offsite laundry",
};
